// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__psFw2","fadeOut":"Loader_fadeOut__n8s0r","loaderGif":"Loader_loaderGif__N9eoh","scaleIn":"Loader_scaleIn__VuV2m"};